import type { Fetcher } from "../fetcher";
import type { ApiSingleResponse } from "../types/api";
import type { FinanceSummaryDTO, FinanceSummaryParams } from "./types";

export function createFinanceRepository(fetcher: Fetcher) {
  return {
    async summary(params: FinanceSummaryParams = {}): Promise<FinanceSummaryDTO> {
      const qs = new URLSearchParams();
      if (params.year !== undefined) qs.set("year", String(params.year));
      const query = qs.toString();
      const res = await fetcher<ApiSingleResponse<FinanceSummaryDTO>>(
        `/finance/summary${query ? `?${query}` : ""}`,
      );
      return res.data;
    },
  };
}

export type FinanceRepository = ReturnType<typeof createFinanceRepository>;
